/** @file Debounced save of the dock layout JSON to settings.ui.layout. */
import { api } from '../../api/api';
import type { ApiClient } from '../../api/createApiClient';
import { updateUiSettings } from './updateUiSettings';

let timer: ReturnType<typeof setTimeout> | undefined;

/** Saves `layout` after `delayMs` without newer calls; failures are dropped (the next change retries). */
export function scheduleLayoutSave(layout: unknown, client: Pick<ApiClient, 'putUiSettings'> = api, delayMs = 1000): void {
  clearTimeout(timer);
  timer = setTimeout(() => {
    updateUiSettings(client, { layout }).catch(() => undefined);
  }, delayMs);
}
